/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import BannerRenewalPhase1 from 'assets/images/campaign-renewal/renewal_banner_phase1.png';
import BannerRenewalPhase2 from 'assets/images/campaign-renewal/renewal_bell_target.png';
import BannerRenewalPhase3 from 'assets/images/campaign-renewal/renewal_comment_bell.png';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface BannerRenewalPanelProps {
  campaign_phase: number;
}

const BannerRenewalPanel = (props: BannerRenewalPanelProps) => {
  const { campaign_phase } = props;
  const handleClick = () => {
    createTrack('Acesso a renovaçao através do Banner');
    window.open('/renovacao', '_parent');
  };
  let bgColor = '';

  if (campaign_phase === 1 || campaign_phase === 3) {
    bgColor = '#14c585';
  }

  if (campaign_phase === 2) {
    bgColor = '#f0f5fd';
  }

  return (
    <Container className="pt-1" style={{ backgroundColor: bgColor }}>
      <div className="container" style={{ backgroundColor: bgColor }}>
        <div className="row align-items-center">
          {campaign_phase === 1 && (
            <>
              <div className="col-md-6 pt-2">
                <p
                  className="px-2 pt-1"
                  style={{ backgroundColor: '#ffffff', width: '226px', borderRadius: '5px' }}
                >
                  <strong>RENOVAÇÃO DA ASSINATURA</strong>
                </p>
                <p style={{ color: '#ffffff' }}>
                  <strong>Estamos no período de renovação da sua assinatura</strong> <br />
                  Conheça a melhor condição de renovação clicando no link abaixo.
                </p>
                <button
                  className="px-2 pt-2 pb-1 mb-3"
                  style={{
                    backgroundColor: '#ffbf3b',
                    borderRadius: '5px',
                    border: '2px solid #ffffff',
                  }}
                  onClick={() => handleClick()}
                >
                  <strong>Confira o que preparamos para sua empresa</strong>
                </button>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div
                    className="col-md-6 d-flex align-items-center pr-1"
                    style={{ fontSize: '18px' }}
                  >
                    <p style={{ color: '#ffffff' }}>
                      O ConLicitação oferece <strong>benefícios para a renovação</strong> antecipada
                      de assinatura.
                    </p>
                  </div>
                  <div className="col-md-4 d-flex justify-content-center pl-0">
                    <img
                      src={BannerRenewalPhase1}
                      alt="Banner Renovação"
                      style={{ height: '175px' }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {campaign_phase === 2 && (
            <>
              <div className="col-md-6 pt-2">
                <p
                  className="px-2 pt-1"
                  style={{
                    backgroundColor: '#14c585',
                    width: '226px',
                    borderRadius: '5px',
                    color: '#ffffff',
                  }}
                >
                  <strong>RENOVAÇÃO DA ASSINATURA</strong>
                </p>
                <p style={{ color: '#000000' }}>
                  <strong>A sua assinatura no ConLicitação está em período de renovação</strong>{' '}
                  <br />
                  Confira no link abaixo os benefícios para a renovação antecipada
                </p>
                <button
                  className="px-2 pt-2 pb-1 mb-3"
                  style={{
                    backgroundColor: '#ffbf3b',
                    borderRadius: '5px',
                    border: '1px solid #ffffff',
                  }}
                  onClick={() => handleClick()}
                >
                  <strong>Conheça os benefícios</strong>
                </button>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div
                    className="col-md-6 d-flex align-items-center pr-1"
                    style={{ fontSize: '18px' }}
                  >
                    <p style={{ color: '#000000' }}>
                      <strong>Renove a sua assinatura </strong>e continue acessando os serviços do
                      ConLicitação
                    </p>
                  </div>
                  <div className="col-md-4 d-flex justify-content-center pl-0">
                    <img
                      src={BannerRenewalPhase2}
                      alt="Banner 2 Renovação"
                      style={{ height: '150px' }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {campaign_phase === 3 && (
            <>
              <div className="col-md-6 pt-2">
                <p
                  className="px-2 pt-1"
                  style={{ backgroundColor: '#ffffff', width: '226px', borderRadius: '5px' }}
                >
                  <strong>RENOVAÇÃO DA ASSINATURA</strong>
                </p>
                <p style={{ color: '#ffffff' }}>
                  <strong>A assinatura de sua empresa expirará em breve.</strong> <br />
                  Aproveite os benefícios da renovação automática de assinatura
                </p>
                <button
                  className="px-2 pt-2 pb-1 mb-3"
                  style={{
                    backgroundColor: '#ffbf3b',
                    borderRadius: '5px',
                    border: '2px solid #ffffff',
                  }}
                  onClick={() => handleClick()}
                >
                  <strong>Conheça aqui o que preparamos para sua empresa</strong>
                </button>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 d-flex justify-content-center pr-1">
                    <img
                      src={BannerRenewalPhase3}
                      alt="Banner 3 Renovação"
                      style={{ height: '125px' }}
                    />
                  </div>
                  <div
                    className="col-md-6 d-flex align-items-center pl-0"
                    style={{ fontSize: '18px' }}
                  >
                    <p style={{ color: '#ffffff' }}>
                      <strong>
                        Não permita que o seu acesso ao ConLicitação seja interrompido
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export default BannerRenewalPanel;
